import styled from 'styled-components'

export const ErrorBannerContainer = styled.div`
  margin-bottom: 24px;
`
export const Info = styled.div`
  margin-bottom: 24px;
`
